import { useQuery } from '@tanstack/react-query';
import { getCustomerSegmentById } from '../api/customerSegments';

export function useCustomerSegment(id: string | null) {
  return useQuery({
    queryKey: ['customer-segments', id],
    queryFn: () => getCustomerSegmentById(id!),
    enabled: id !== null,
  });
}
